<template>
  <div class="combo-detail-product-list">
    <div class="combo-detail-product-list-header">
      {{ blockTitle }}（{{ list.length }}）
    </div>
    <div class="combo-detail-product-list-item"
         v-for="(item, index) in realList"
         :key="index"
    >
      <div class="combo-detail-product-list-item-title ym-line-ellipsis"
           :class="{ 'is-member': item.isMember }"
      >
        {{ item.title }}
      </div>
      <div v-if="item.isMember"
           class="combo-detail-product-list-item-status"
      >
        <ym-icon class="icon"
                 name="round-check-fill"
        />
        已购买
      </div>
    </div>
    <div v-if="list.length > 4"
         class="combo-detail-product-list-action"
         @click="handleListAction(4)"
    >
      {{ realList.length > 4 ? '收起' : '展开' }}全部
      <ym-icon class="combo-detail-product-list-action-icon"
               :class="{ 'up-icon': realList.length > 4 }"
               name="down"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ComboDetailProductList',
    props: {
      blockTitle: {
        type: String,
        default: '系列包含以下内容',
      },
      list: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        realList: [],
      };
    },
    methods: {
      fetchRealList(length, action = 'more') {
        const { list } = this;
        if (action === 'less') {
          if (list.length <= 4) return list;
          return list.slice(0, 4);
        }
        return list;
      },
      handleListAction(length) {
        if (this.realList.length > 4) {
          this.realList = this.fetchRealList(length, 'less');
          return;
        }
        this.realList = this.fetchRealList(length, 'more');
      },
    },
    created() {
      this.realList = this.fetchRealList(4, 'less');
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .combo-detail-product-list {
    box-sizing: border-box;
    margin-bottom: @size-small;
    padding: 0 @size-base @size-extra-small @size-base;
    background: @color-white;

    &-header {
      height: 90px;
      display: flex;
      align-items: center;
      color: @color-text-base;
      font-size: @font-size-medium;
      font-weight: @font-weight-strong;
    }

    &-item {
      box-sizing: border-box;
      width: 100%;
      height: 80px;
      padding: 0 @size-base;
      margin-bottom: @size-extra-small;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: @color-text-light;
      font-size: @font-size-base;
      background: @background-color-lighter;
      border-radius: @border-radius-normal * 2;
      &.disabled {
        color: @color-text-lighter;
      }

      &-title {
        flex: 1;

        &.is-member {
          color: @color-text-lighter;
          text-decoration: line-through;
        }
      }
      &-status {
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-text-lighter;
        .icon {
          margin-right: @size-extra-small;
          font-size: 30px;
        }
      }
    }

    &-action {
      box-sizing: border-box;
      margin: @size-base 0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-text-light;
      font-size: 28px;
      line-height: 1;

      &-icon {
        margin-left: @size-extra-small;
        font-size: 30px;

        &.up-icon {
          transform: rotate(180deg);
        }
      }
    }
  }

</style>
